import { automationLegacyCopy } from './legacyCopy/automation';
import { ccLegacyCopy } from './legacyCopy/cc';
import { instanceSubtaskLegacyCopy } from './legacyCopy/instanceSubtask';
import { miscLegacyCopy } from './legacyCopy/misc';
import { sentItemLegacyCopy } from './legacyCopy/sentItem';
import { CopyPack, IssueKind } from './types';

const merged: Partial<CopyPack> = {
  ...automationLegacyCopy,
  ...sentItemLegacyCopy,
  ...instanceSubtaskLegacyCopy,
  ...ccLegacyCopy,
  ...miscLegacyCopy
};

const missingKinds = (Object.values(IssueKind) as IssueKind[]).filter((kind) => !merged[kind]);
if (missingKinds.length) {
  throw new Error(`legacyCopy.ts is missing entries for IssueKind(s): ${missingKinds.join(', ')}`);
}

/** Today's current copy, ported as-is and keyed by `IssueKind`. Used by the
 * still-live old UI (via the thin wrappers in `../ParticipantDialog.tsx`)
 * and the two secondary consumers. `newCopy.ts` (Phase 3 of the issues
 * redesign) is the only place new copy gets authored. */
export const legacyCopy: CopyPack = merged as CopyPack;
